<template>
    <div
        v-if="isMessageActive || force"
        :key="rerenderIndex"
        :class="[
            'component',
            'component__induction_message',
            `component__induction_message--${theme}`
        ]"
    >
        <div class="container">
            <div :class="[
            'component__induction_message_box',
            pendingLeave ? 'component__induction_message_box--leave' : ''
            ]">
                <template v-if="closeActive">
                    <div class="component__induction_message_box_close">
                        <component-button
                            class="component__induction_message_box_close_button"
                            :theme="''"
                            :icon="true"
                            :icon-name="'x'"
                            :icon-raw="true"
                            :name="'component-induction-message-close-button'"
                            @click="performCloseMessage"
                        >
                        </component-button>
                    </div>
                </template>
                <div class="columns is-block-mobile fullheight">
                    <div class="column is-6">
                        <div class="component__induction_message_box_content">
                            <div class="component__induction_message_box_content_title">{{ title }}</div>
                            <div class="component__induction_message_box_content_text">
                                <template v-if="contentHtml">
                                    <div v-html="content"></div>
                                </template>
                                <template v-else>{{ content }}</template>
                            </div>
                        </div>
                    </div>
                    <div class="column is-6">
                        <div class="component__induction_message_box_banner">
                            <div class="columns is-block-mobile fullheight has-text-centered is-vcentered">
                                <div class="column">
                                    <div class="component__induction_message_box_banner_image">
                                        <img
                                            :src="require(`@/assets/img/${iconNameOutput}`)"
                                            :alt="''"
                                        >
                                    </div>
                                    <div
                                        v-if="bannerLinkTo || bannerLinkToExternal || $slots.bannertext"
                                        class="component__induction_message_box_banner_text"
                                    >
                                        <template v-if="$slots.bannertext">
                                            <slot name="bannertext"></slot>
                                        </template>
                                        <template v-else>
                                            <component-text
                                                :html="true"
                                                :is-slot="true"
                                            >
                                                <component-button
                                                    :name="'component-induction-message'"
                                                    :text="true"
                                                    :underline="true"
                                                    :theme="''"
                                                    :icon="true"
                                                    :icon-name="'external-link'"
                                                    :icon-align="'right'"
                                                    :size="''"
                                                    :to="bannerLinkTo"
                                                    :to-external="bannerLinkToExternal"
                                                    :target="true"
                                                >{{ bannerLinkText }}
                                                </component-button>
                                            </component-text>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ComponentText from '@/components/default/shared/ComponentText'
import ComponentButton from '@/components/default/shared/ComponentButton'
import { User } from '@/User'

export default {
  name: 'component-induction-message',
  data () {
    return {
      pendingLeave: false,
      rerenderIndex: 0,
      user: new User()
    }
  },
  components: { ComponentButton, ComponentText },
  props: {
    title: {
      type: String,
      required: true
    },
    content: {
      type: String,
      required: true
    },
    contentHtml: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: false
    },
    closeActive: {
      type: Boolean,
      default: true
    },
    bannerIcon: {
      type: String
    },
    bannerText: {
      type: String,
      default: 'Want to know more?'
    },
    bannerLinkText: {
      type: String,
      default: 'Check our support guide'
    },
    bannerLinkTo: {
      type: Object,
      default: () => {
      }
    },
    bannerLinkToExternal: {
      type: String
    },
    theme: {
      type: String,
      default: 'primary'
    },
    routeName: {
      type: String
    }
  },
  computed: {
    isMessageActive () {
      return this.$store.getters.getDefaultInductionMessagesIsMessageActive(this.routeName)
    },
    iconNameOutput () {
      const theme = this.theme
      let iconName

      if (this.bannerIcon) {
        iconName = this.bannerIcon
      } else {
        switch (theme) {
          case 'primary':
            iconName = 'onboarding-blue.svg'
            break
          case 'secondary':
            iconName = 'onboarding-orange.svg'
            break
          case 'tertiary':
            iconName = 'onboarding-green.svg'
            break
          case 'danger':
            iconName = 'onboarding-danger.svg'
            break
          default:
            iconName = 'onboarding-blue.svg'
            break
        }
      }
      return iconName
    }
  },
  methods: {
    performCloseMessage () {
      this.pendingLeave = true
      setTimeout(() => {
        this.$store.dispatch('defaultInductionMessagesSet', { routeName: this.routeName, type: 'induction', active: false }).then(() => {
          this.pendingLeave = false
        })
      }, 300)
    }
  },
  mounted () {
    this.$eventBus.$on('reset-onboarding-message', () => {
      this.rerenderIndex++
      this.pendingLeave = false
    })
  },
  beforeDestroy () {
    this.$eventBus.$off('reset-onboarding-message')
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/default/shared/componentinductionmessage";
</style>
